export default {
    edit: 'Izmeni',
    location: 'Lokacija + Uslovi',
    filter: 'Filter',
};
